export default __webpack_public_path__ + "static/media/login.7ab0815d.png";